import { AfterViewInit, Component, computed, Inject, OnDestroy, OnInit, PLATFORM_ID, signal } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
//import { gsap } from 'gsap';
import { ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilService } from 'src/app/shared/helper/util.service';
import { ConfirmEmailService } from '../confirm-email/confirm-email.service';
import { emailCheckAsyncValidator } from '../../Validators/checkEmailExists.validator';
import { passwordValidator } from '../../Validators/checkPassword.validator';
import { matchPasswordValidator } from '../../Validators/checkBothPasswords.validator';
import { AuthService } from '@auth0/auth0-angular';
import { gsap } from 'gsap';
import auth0 from 'auth0-js';
import { authConfig } from 'src/app/app.module';
import { NgxSpinnerService, Spinner } from 'ngx-spinner';
import { companyExistsAsyncValidator } from '../../Validators/checkCompanyExists.validator';
import { CreateUserService } from '../manage-users/create-user/create-user.service';
import { registeredEmailAsyncValidator } from '../../Validators/checkRegisteredEmail.validator';
import { passwordSignUpValidator } from '../../Validators/checkValidPassword.validator';

interface Company {
  id: number;
  companyName: string;
}

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit, AfterViewInit, OnDestroy {

  // ==================== COMPONENT STATE PROPERTIES - START ====================

  forgotGroup = false;
  // Set "true" to view forgot password/confirm email/verify email form; 
  // Set "false" to view login/signup form;

  isForgetPassword = false
  // Set "true" to view forgot password form; 
  // Set "false" to view reset password form;

  isConfirmEmail = false
  // Set "true" to view confirm email form; 
  // Set "false" to view verify email form;

  isSignup = true
  // Set "true" to view login form; 
  // Set "false" to view signup form;

  signUpSteptwo = false
  // Set "true" to view signup step 2; 
  // Set "false" to view signup step 1;

  // Flag to control visibility of password requirements
  passwordReqVisible = false;

  // Flag to track if password field is currently focused
  isPasswordFieldFocused = false;

  // Flag to control whether eye animations should track mouse movement
  isEyeTrackingEnabled = true;

  // Company selection properties
  selectedCompany: string[] = [];
  isCompanyOpen = false;
  private clickOutsideListener?: (event: Event) => void;

  // Search functionality with signals
  searchTerm = signal('');
  isOtherSelected = signal(false);
  customCompanyName = signal('');

  companies: any[] = [];
  filteredCompanies = computed(() => {
    const search = this.searchTerm().toLowerCase().trim();
    if (!search) {
      return this.companies;
    }
    return this.companies.filter(company =>
      company.companyName.toLowerCase().includes(search)
    );
  });

  // Computed signal to show "Other" option
  showOtherOption = computed(() => {
    // Always show "Other" option at the end of the list
    return true;
  });

  emailError = "Please Enter valid email"
  showToastMessage = false
  currentDate = ''
  countryName = ''
  operatingSystem = ''
  browserName = ''
  showErrorToast = false;
  error: any = ''
  successMsg = ''
  showSuccessToast = false
  globalEmail: any = '';
  errMsgText: string = null;
  existingUserStatus: any;
  emailForm: any;
  capitalLetterFlag = false;
  uniqueCharacterFlag = false;
  stringLengthGt12Flag = false;
  stringNumFlag = false;
  emailNotExistsErr: string = '';
  isSubmitted = false;
  // ==================== COMPONENT STATE PROPERTIES - END ====================

  // ==================== OTP VERIFICATION PROPERTIES - START ====================
  readonly OTP_LENGTH = 8;
  readonly OTP_PATTERN = /^[0-9]$/;
  readonly OTP_INPUT_TYPE = 'numeric';
  
  otpDigits: string[] = Array(this.OTP_LENGTH).fill('');
  otpError: string = '';
  isOtpValid: boolean = false;
  otpIndices: number[] = Array.from({ length: this.OTP_LENGTH }, (_, i) => i);
  // ==================== OTP VERIFICATION PROPERTIES - END ====================

  // ==================== TIMER AND COUNTDOWN PROPERTIES - START ====================
  timer: string = '03:00'; // Initial timer value for 3 minutes;
  private countdownInterval: any;
  isShowTimer: boolean = false;
  codeExpText = "Code Expires in"
  // ==================== TIMER AND COUNTDOWN PROPERTIES - END ====================

  // ==================== FORM PROPERTIES - START ====================
  loginForm: FormGroup;
  mainLoginForm: FormGroup;
  resetForm: FormGroup<{ verificationCode: FormControl<string>; newPassword: FormControl<string>; confirmPassword: FormControl<string>; }>;
  // ==================== FORM PROPERTIES - END ====================

  // ==================== PASSWORD VISIBILITY PROPERTIES - START ====================
  isPasswordHidden = true;
  isConfirmPasswordHidden: boolean = true;
  // ==================== PASSWORD VISIBILITY PROPERTIES - END ====================

  // ==================== FORM STATE SIGNALS - START ====================
  isLoginForm = signal(false);
  isForgotPassword = signal(true);
  isResetPassword = signal(false);
  isPasswordValid = signal({
    hasSpecialCharacter: false,
    hasCapitalLetter: false,
    isLongEnough: false,
    hasNumber: false
  });
  // ==================== FORM STATE SIGNALS - END ====================

  // ==================== CONSTRUCTOR AND DEPENDENCY INJECTION - START ====================
  constructor(@Inject(PLATFORM_ID) private platformId: Object,
    public fb: FormBuilder,
    public cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private confirmEmail: ConfirmEmailService,
    private utilService: UtilService,
    public auth: AuthService,
    public spinnerService: NgxSpinnerService,
    public confirmEmailService: ConfirmEmailService) {
    this.setFormControls()
    this.activatedRoute.paramMap.subscribe((res: any) => {
      let { id } = res?.params;
    })
  }
  // ==================== CONSTRUCTOR AND DEPENDENCY INJECTION - END ====================

  // ==================== LIFECYCLE METHODS - START ====================
  ngOnInit() {    
    let path = this.router.url.split('/')[1];
    this.forgotGroup = (path == 'login' || path == 'signup') ? false : true;
    if (this.forgotGroup)
      this.isForgetPassword = true;
    this.getCompaniesList(); 
    this.setFormControls();
    this.currentDate = this.formatDate();
    this.countryName = 'India' // temporarly set country for testing
    this.operatingSystem = this.getOS();
    this.browserName = this.getBrowserName();
    this.confirmEmail.email$.subscribe(res => {
      this.globalEmail = res;
    })
  }

  ngAfterViewInit(): void {
    this.initializeEyeAnimations();

    if (isPlatformBrowser(this.platformId)) {
      //  this.animateColorBalls();
      this.resetForm.get('newPassword')?.valueChanges.subscribe((password) => {
        this.updatePasswordValidation(password);
        if (this.isResetPassword()) {
          this.updatePasswordValidation(password);
        }
      });
      this.resetForm.get('confirmPassword')?.valueChanges.subscribe((password) => {
        this.updatePasswordValidation(password);
        if (this.isResetPassword()) {
          this.updatePasswordValidation(password);
        }
      });

      // Subscribe to signup password changes for validation and requirements visibility
      this.mainLoginForm.get('passForSignup')?.valueChanges.subscribe((password) => {
        if (password !== null && password !== undefined) {
          this.updatePasswordValidation(password);
        }
      });

      // Add click outside listener for company dropdown
      this.clickOutsideListener = (event: Event) => {
        const companyDropdown = document.querySelector('.formControl.company');
        const searchInput = document.querySelector('.searchInput');
        const target = event.target as Node;

        // Don't close if clicking on the search input or within the dropdown
        if (companyDropdown && !companyDropdown.contains(target) && target !== searchInput) {
          this.isCompanyOpen = false;
          this.cdr.detectChanges();
        }
      };
      document.addEventListener('click', this.clickOutsideListener);

      this.cdr.detectChanges();
    }
  }

  ngOnDestroy(): void {
    clearInterval(this.countdownInterval);

    // Clean up click outside listener
    if (this.clickOutsideListener) {
      document.removeEventListener('click', this.clickOutsideListener);
    }
  }
  // ==================== LIFECYCLE METHODS - END ====================

  // ==================== FORM SETUP AND CONFIGURATION - START ====================
  
  /**
   * Generates OTP form controls dynamically based on OTP_LENGTH
   */
  private generateOtpControls(): { [key: string]: FormControl } {
    const otpControls: { [key: string]: FormControl } = {};
    for (let i = 1; i <= this.OTP_LENGTH; i++) {
      otpControls[`otpDigit${i}`] = new FormControl('', [
        Validators.required,
        Validators.pattern(this.OTP_PATTERN)
      ]);
    }
    return otpControls;
  }

  setFormControls() {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,10}$')], [emailCheckAsyncValidator(this.confirmEmail)]]
    })
    this.mainLoginForm = this.fb.group({
      emailForLogin: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,10}$')], [emailCheckAsyncValidator(this.confirmEmail)]],
      passForLogin: ['', [Validators.required]],
      firstNameForSignUp: ['', [
        Validators.required,
        Validators.pattern('^[a-zA-Z ]*$'),
        Validators.minLength(2),
        Validators.maxLength(50),
      ]
      ],
      lastNameForSignUp: ['', [
        Validators.required,
        Validators.pattern('^[a-zA-Z ]*$'),
        Validators.minLength(2),
        Validators.maxLength(50),
      ]
      ],
      emailForSignUp: ['',[Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,10}$')], [registeredEmailAsyncValidator(this.confirmEmail)]],
      passForSignup: ['',[Validators.required, passwordSignUpValidator()]],
      selectedCompany: ['', [Validators.required]],
      customCompanyName: ['',[Validators.required],[companyExistsAsyncValidator(this.companies)]],
      // OTP verification controls - generated dynamically
    //  ...this.generateOtpControls(),
      verificationCodeForSignUp: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(8)]],

    })
    this.resetForm = this.fb.group({
      verificationCode: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(8)]],
      newPassword: ['', [Validators.required, passwordValidator()]],
      confirmPassword: ['', [Validators.required]],
    }, { validators: matchPasswordValidator('newPassword', 'confirmPassword') });

  }
  // ==================== FORM SETUP AND CONFIGURATION - END ====================

  // ==================== EYE ANIMATIONS AND INTERACTIONS - START ====================
  private initializeEyeAnimations(): void {
    const eyes = [
      '#shape01_eye',
      '#shape02_left_eye', '#shape02_right_eye',
      '#shape03_left_eye', '#shape03_right_eye',
      '#shape04_left_eye', '#shape04_right_eye',
      '#shape05_left_eye', '#shape05_right_eye',
      '#shape06_left_eye', '#shape06_right_eye',
      '#shape07_left_eye', '#shape07_right_eye'
    ];

    // Group eyes by shape for synchronized blinking
    const eyeGroups = [
      ['#shape01_eye'],
      ['#shape02_left_eye', '#shape02_right_eye'],
      ['#shape03_left_eye', '#shape03_right_eye'],
      ['#shape04_left_eye', '#shape04_right_eye'],
      ['#shape05_left_eye', '#shape05_right_eye'],
      ['#shape06_left_eye', '#shape06_right_eye'],
      ['#shape07_left_eye', '#shape07_right_eye']
    ];

    // Track which shapes are currently blinking
    const blinkingShapes = new Set();

    // Blinking animation function
    const blinkShape = (eyeGroup: string[]) => {
      if (blinkingShapes.has(eyeGroup)) return; // Prevent overlapping blinks

      blinkingShapes.add(eyeGroup);

      eyeGroup.forEach(eyeId => {
        const eye = document.querySelector(eyeId) as SVGCircleElement;
        if (eye) {
          // Store original radius if not already stored
          if (!eye.hasAttribute('data-original-r')) {
            eye.setAttribute('data-original-r', eye.getAttribute('r') || '16');
          }

          const originalRadius = parseFloat(eye.getAttribute('data-original-r') || '16');

          // Blink animation: shrink to 0, then back to original
          gsap.timeline()
            .to(eye, {
              duration: 0.08,
              ease: "power2.inOut",
              attr: { r: 0 }
            })
            .to(eye, {
              duration: 0.08,
              ease: "power2.inOut",
              attr: { r: originalRadius },
              onComplete: () => {
                blinkingShapes.delete(eyeGroup);
              }
            });
        }
      });
    };

    // Start random blinking for all shapes
    const startBlinking = () => {
      eyeGroups.forEach((eyeGroup, index) => {
        const scheduleNextBlink = () => {
          
          // Non-security random delay (UI/retry timing only)
          const randomDelay = Math.floor(Math.random() * 4000)+ 2000; 

          setTimeout(() => {
            // Check if any other shape is currently blinking
            if (blinkingShapes.size === 0) {
              blinkShape(eyeGroup);
            }
            scheduleNextBlink(); // Schedule the next blink
          }, randomDelay);
        };

        // Start with random initial delay to stagger the first blinks
        setTimeout(() => {
          scheduleNextBlink();
        }, Math.floor(Math.random() * 3000)); // NOSONAR: Safe for UI animation timing
      });
    };

    // Initialize blinking
    startBlinking();

    // Mouse follow animation
    document.addEventListener('mousemove', (e) => {
      // Only track mouse if eye tracking is enabled (not paused for privacy)
      if (!this.isEyeTrackingEnabled) return;

      eyes.forEach(eyeId => {
        const eye = document.querySelector(eyeId) as SVGCircleElement;
        if (eye) {
          // Get the SVG container to calculate relative positions
          const svg = document.querySelector('#eyesAnimation') as SVGSVGElement;
          if (svg) {
            // Get SVG bounding box and mouse position relative to SVG
            const svgRect = svg.getBoundingClientRect();
            const svgMouseX = e.clientX - svgRect.left;
            const svgMouseY = e.clientY - svgRect.top;

            // Scale mouse coordinates to SVG viewBox (800x800)
            const scaleX = 800 / svgRect.width;
            const scaleY = 800 / svgRect.height;
            const mouseX = svgMouseX * scaleX;
            const mouseY = svgMouseY * scaleY;

            // Get original eye position (store if not already stored)
            if (!eye.hasAttribute('data-original-cx')) {
              eye.setAttribute('data-original-cx', eye.getAttribute('cx') || '0');
              eye.setAttribute('data-original-cy', eye.getAttribute('cy') || '0');
            }

            const originalCx = parseFloat(eye.getAttribute('data-original-cx') || '0');
            const originalCy = parseFloat(eye.getAttribute('data-original-cy') || '0');
            const eyeRadius = parseFloat(eye.getAttribute('r') || '16');

            // Calculate direction from original eye position to mouse
            const deltaX = mouseX - originalCx;
            const deltaY = mouseY - originalCy;
            const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);

            // Maximum movement range for the pupil (should be less than eye socket radius)
            // Assuming eye socket is roughly 3x the pupil size, so max movement is about 1/3 of that
            const maxMove = Math.max(eyeRadius * 0.8, 8); // At least 8 pixels movement

            // Calculate new position (limit movement within the eye socket)
            let moveX = 0;
            let moveY = 0;

            if (distance > 0) {
              const normalizedX = deltaX / distance;
              const normalizedY = deltaY / distance;

              // Limit movement to maxMove radius from original position
              const actualMove = Math.min(maxMove, distance * 0.05);
              moveX = normalizedX * actualMove;
              moveY = normalizedY * actualMove;
            }

            // Calculate final position relative to original position
            const newCx = originalCx + moveX;
            const newCy = originalCy + moveY;

            // Console log for live eye position tracking
            // console.log(`Eye: ${eyeId} | Position: (${newCx.toFixed(2)}, ${newCy.toFixed(2)}) | Original: (${originalCx}, ${originalCy}) | Move: (${moveX.toFixed(2)}, ${moveY.toFixed(2)})`);

            // Animate the eye position using GSAP
            gsap.to(eye, {
              duration: 0.3,
              ease: "power2.out",
              attr: {
                cx: newCx,
                cy: newCy
              }
            });
          }
        }
      });
    });
  }

  // Method to position all eyes to look away when password is visible
  lookAwayForPrivacy(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    // Disable mouse tracking to pause eye animations
    this.isEyeTrackingEnabled = false;

    // All eye selectors with their exact positions from the console log
    const eyePositions: { [key: string]: { x: number; y: number } } = {
      '#shape01_eye': { x: 404.52, y: 174.14 },
      '#shape02_left_eye': { x: 417.05, y: 387.55 },
      '#shape02_right_eye': { x: 471.12, y: 398.27 },
      '#shape03_left_eye': { x: 606.42, y: 638.07 },
      '#shape03_right_eye': { x: 670.55, y: 629.40 },
      '#shape04_left_eye': { x: 229.58, y: 391.45 },
      '#shape04_right_eye': { x: 276.97, y: 375.61 },
      '#shape05_left_eye': { x: 74.00, y: 492.77 },
      '#shape05_right_eye': { x: 129.24, y: 493.28 },
      '#shape06_left_eye': { x: 172.77, y: 169.59 },
      '#shape06_right_eye': { x: 219.96, y: 190.29 },
      '#shape07_left_eye': { x: 573.16, y: 186.28 },
      '#shape07_right_eye': { x: 624.09, y: 174.85 }
    };

    // Set each eye to its specific position
    Object.entries(eyePositions).forEach(([eyeSelector, position]) => {
      const eye = document.querySelector(eyeSelector) as SVGCircleElement;
      if (eye) {
        // Animate the eye to the exact position
        gsap.to(eye, {
          duration: 0.4,
          ease: "power2.out",
          attr: {
            cx: position.x,
            cy: position.y
          }
        });
      }
    });
  }

  // Method to resume normal mouse tracking
  resumeMouseTracking(): void {
    // Re-enable mouse tracking
    this.isEyeTrackingEnabled = true;

    // Simply trigger the existing mouse tracking logic by simulating a mouse move
    const centerX = window.innerWidth / 2;
    const centerY = window.innerHeight / 2;

    // Create a fake mouse event to reset eyes to center
    const fakeMoveEvent = new MouseEvent('mousemove', {
      clientX: centerX,
      clientY: centerY
    });

    // Dispatch the event to restart normal tracking
    document.dispatchEvent(fakeMoveEvent);
  }
  // ==================== EYE ANIMATIONS AND INTERACTIONS - END ====================

  // ==================== UTILITY METHODS - START ====================
  formatDate() {
    const options: any = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      timeZone: 'Asia/Kolkata',
    };
    const formatter = new Intl.DateTimeFormat('en-US', options);
    const date = new Date();
    const formattedDate = formatter.format(date);
    // Add the timezone information
    return `${formattedDate} (Asia/Kolkata)`;
  }

  getOS() {
    const userAgent = navigator.userAgent;

    let os = "Unknown OS";

    if (userAgent.includes("Windows")) {
      os = "Windows";
    } else if (userAgent.includes("Macintosh")) {
      os = "macOS";
    } else if (userAgent.includes("Linux")) {
      os = "Linux";
    } else if (userAgent.includes("Android")) {
      os = "Android";
    } else if (userAgent.includes("like Mac")) {
      os = "iOS";
    }

    return os;
  }

  getBrowserName() {
    const userAgent = navigator.userAgent;
    let browserName = "Unknown Browser";

    if (userAgent.includes("Chrome")) {
      browserName = "Google Chrome";
    } else if (userAgent.includes("Firefox")) {
      browserName = "Mozilla Firefox";
    } else if (userAgent.includes("Safari")) {
      browserName = "Apple Safari";
    } else if (userAgent.includes("MSIE") || userAgent.includes("Trident")) {
      browserName = "Microsoft Internet Explorer";
    } else if (userAgent.includes("Edge")) {
      browserName = "Microsoft Edge";
    } else if (userAgent.includes("Opera") || userAgent.includes("OPR")) {
      browserName = "Opera";
    }

    return browserName;
  }

  handlePageVisibility() {
    document.addEventListener('visibilitychange', () => {
});
  }
  // ==================== UTILITY METHODS - END ====================

  // ==================== PASSWORD VISIBILITY METHODS - START ====================
  showHidePass(): void {
    this.isPasswordHidden = !this.isPasswordHidden;

    // If any password field is visible (not hidden), make eyes look away for privacy
    if (!this.isPasswordHidden || !this.isConfirmPasswordHidden) {
      this.lookAwayForPrivacy();
    } else {
      // Both password fields are now hidden, resume normal mouse tracking
      this.resumeMouseTracking();
    }
  }

  showHideConfirmPass(): void {
    this.isConfirmPasswordHidden = !this.isConfirmPasswordHidden;

    // If any password field is visible (not hidden), make eyes look away for privacy
    if (!this.isPasswordHidden || !this.isConfirmPasswordHidden) {
      this.lookAwayForPrivacy();
    } else {
      // Both password fields are now hidden, resume normal mouse tracking
      this.resumeMouseTracking();
    }
  }
  // ==================== PASSWORD VISIBILITY METHODS - END ====================

  // ==================== COMPANY SELECTION METHODS - START ====================
  showOptions(): void {
    this.isCompanyOpen = !this.isCompanyOpen;
    // Reset search when opening dropdown
    if (this.isCompanyOpen) {
      this.searchTerm.set('');
    }
  }

  selectCompany(companyInfo: any): void {
    if (companyInfo.companyName === 'Other') {
      // Handle "Other" selection
      this.isOtherSelected.set(true);
      this.selectedCompany = [companyInfo.companyName]; // This will always show "Other" in the dropdown
      // // Clear form value until custom company is entered
      this.mainLoginForm.patchValue({ selectedCompany: '', customCompanyName: '' });
      this.customCompanyName.set(''); // Reset custom company name
      // Reset the customCompanyName field in the form
    } else {
      // Handle regular company selection
      this.isOtherSelected.set(false);
      this.customCompanyName.set('');
      this.mainLoginForm.get('customCompanyName').reset();
      this.selectedCompany = [companyInfo.companyName];
      this.mainLoginForm.patchValue({ selectedCompany: companyInfo.id, customCompanyName: '' });
    }

    // Close the dropdown after selection
    this.isCompanyOpen = false;
  }

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchTerm.set(input.value);
  }

  onCustomCompanyChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const customName = input.value.trim();
    this.customCompanyName.set(customName);

    // Keep "Other" displayed in dropdown, but update form with custom company name
    if (customName) {
      // selectedCompany array stays as ["Other"] for display purposes
      // but form gets the actual custom company name
      this.mainLoginForm.patchValue({
        selectedCompany: null,
        customCompanyName: customName
      });
    } else {
      // If custom company name is empty, clear the form value but keep "Other" selected
      this.mainLoginForm.patchValue({
        selectedCompany: '',
        customCompanyName: ''
      });
    }
  }

  clearSearch(): void {
    this.searchTerm.set('');
  }

  trackByCompanyId(index: number, item: Company): number {
    return item.id;
  }
  // ==================== COMPANY SELECTION METHODS - END ====================

  // ==================== FORM STATE MANAGEMENT METHODS - START ====================
  getNavigation(): () => void {
    if (this.isLoginForm()) {
      return this.showForgotPassword.bind(this);
    } else if (this.isForgotPassword()) {
      return this.showResetPassword.bind(this);
    } else if (this.isResetPassword()) {
      return this.showLogin.bind(this);
    } else {
      return this.showLogin.bind(this);
    }
  }

  showLogin(): void {
    this.isLoginForm.set(true);
    this.isForgotPassword.set(false);
    this.isResetPassword.set(false);
    this.cdr.detectChanges()
  }

  showForgotPassword(): void {
    this.isLoginForm.set(false);
    this.isForgotPassword.set(true);
    this.isResetPassword.set(false);
    this.cdr.detectChanges()
  }

  showResetPassword(): void {
    this.isLoginForm.set(false);
    this.isForgotPassword.set(false);
    this.isResetPassword.set(true);
    this.cdr.detectChanges()
  }


  // ==================== FORM STATE MANAGEMENT METHODS - END ====================

  // ==================== PASSWORD VALIDATION METHODS - START ====================
  private updatePasswordValidation(password: string): void {
    this.isPasswordValid.set({
      hasSpecialCharacter: /[!@#$%^&*()_+=\[\]{};':"\\|,.<>\/?]/.test(password),
      hasCapitalLetter: /[A-Z]/.test(password) && /[a-z]/.test(password),
      hasNumber: /[0-9]/.test(password),
      isLongEnough: password.length >= 8,
    });

    // Update password requirements visibility based on validation
    this.updatePasswordRequirementsVisibility(password);
  }

  // Method to handle password input focus - shows requirements (use case 1)
  onPasswordFocus(): void {
    this.isPasswordFieldFocused = true;
    this.passwordReqVisible = true;
  }

  // Method to handle password input blur - hides requirements (use case 4)
  onPasswordBlur(): void {
    this.isPasswordFieldFocused = false;
    
    // Only hide if all validations pass, otherwise keep visible for user guidance
    const currentPassword = this.mainLoginForm.get('passForSignup')?.value || '';
    this.updatePasswordRequirementsVisibility(currentPassword);
  }

  // Method to update password requirements visibility based on all use cases
  private updatePasswordRequirementsVisibility(password: string): void {
    const passwordValid = this.isPasswordValid();
    const allValidationsPassed = passwordValid.hasSpecialCharacter && 
                                 passwordValid.hasCapitalLetter && 
                                 passwordValid.hasNumber && 
                                 passwordValid.isLongEnough;

    // Use case 1: Show when field is focused
    if (this.isPasswordFieldFocused) {
      this.passwordReqVisible = true;
      return;
    }

    // Use case 2: Show when any validation fails (and password has content)
    if (!allValidationsPassed && password && password.length > 0) {
      this.passwordReqVisible = true;
      return;
    }

    // Use case 3: Hide when all validations pass
    // Use case 4: Hide when not focused and no validation issues
    this.passwordReqVisible = false;
  }

  // Method to manually toggle password requirements visibility
  togglePasswordRequirements(): void {
    this.passwordReqVisible = !this.passwordReqVisible;
  }
  // ==================== PASSWORD VALIDATION METHODS - END ====================

  // ==================== EMAIL VERIFICATION METHODS - START ====================
  sendVerification() {
    let payload = {
      "email": this.loginForm.get('email').value?.toLowerCase()?.trim(),
      "date": this.currentDate,
      "os": this.operatingSystem,
      "browser": this.browserName,
      "isForgotPassword": 'true', // NOSONAR – default value set for forgot password flag
      "location": this.countryName,

    }

    this.confirmEmail.setEmail(this.loginForm.get('email').value?.trim());
    this.confirmEmail.sendEmailVerificationCode(payload).subscribe({
      next: (res: any) => {
        if (res.code == 500) {
          this.error = res.result.error;
          this.showErrorToast = true;
          setTimeout(() => {
            this.showErrorToast = false;
            this.error = ''
          }, 10000)
        }
        else if (res.code == 401) {
          this.error = res.result.error;
          this.showErrorToast = true;
          setTimeout(() => {
            this.showErrorToast = false;
            this.error = ''
          }, 10000)
        }
        else if (res.code == 200) {
          this.isSubmitted = false;
          this.isForgetPassword = false;
          this.startCountdown();
        }
      },
      error: (error) => {
        //  this.spinnerService.hide()
        this.utilService.SharingDataTextMessage.subscribe((res: any) => {
          this.error = res
        })
        this.showErrorToast = true;
        setTimeout(() => { this.showErrorToast = false; this.error = ''; this.utilService.SharingDataTextMessage.next('') }, 5000)
      }
    }
    )
  }
sendVerificationForSignUp() {
    let payload = {
      "email": this.mainLoginForm.get('emailForSignUp').value?.toLowerCase()?.trim(),
      "date": this.currentDate,
      "os": this.operatingSystem,
      "browser": this.browserName,
      "location": this.countryName,

    }

   // this.confirmEmail.setEmail(this.mainLoginForm.get('emailForSignUp').value?.trim());
    this.confirmEmail.sendEmailVerificationCode(payload,'isSignUp').subscribe({
      next: (res: any) => {
        if (res.code == 500) {
          this.error = res.result.error;
          this.showErrorToast = true;
          setTimeout(() => {
            this.showErrorToast = false;
            this.error = ''
          }, 10000)
        }
        else if (res.code == 401) {
          this.error = res.result.error;
          this.showErrorToast = true;
          setTimeout(() => {
            this.showErrorToast = false;
            this.error = ''
          }, 10000)
        }
        else if (res.code == 200) {
          this.isSubmitted = false;
          this.isForgetPassword = false;
          this.signUpSteptwo = true;
          this.showSuccessToast = true;
          this.successMsg = res.result;
          this.mainLoginForm.get('verificationCodeForSignUp').reset();
      
          setTimeout(() => {
            //  this.router.navigate(['/home'])
            this.backToLogin();
            this.showSuccessToast = false;
          }, 3000);
      //    this.startCountdown();
        }
      },
      error: (error) => {
        //  this.spinnerService.hide()
        this.utilService.SharingDataTextMessage.subscribe((res: any) => {
          this.error = res
        })
        this.showErrorToast = true;
        setTimeout(() => { this.showErrorToast = false; this.error = ''; this.utilService.SharingDataTextMessage.next('') }, 5000)
      }
    }
    )
  }
  resendCode(): void {
    this.sendVerification()
  }
   resendCodeForSignUp(): void {
    this.sendVerificationForSignUp()
  }
  // ==================== EMAIL VERIFICATION METHODS - END ====================

  // ==================== VERIFICATION CODE METHODS - START ====================
  verifyCode() {
    let payload = {
      "email": this.globalEmail.toLowerCase()?.trim(),
      "verificationCode": this.resetForm.get('verificationCode').value
    }
    this.confirmEmail.verifyEmailCode(payload).subscribe((res: any) => {
      if (res.code == 200) {
        this.isShowTimer = false;
        this.createPassword();
      } else if (res.code == 500) {
        this.error = res.result.error;
        this.showErrorToast = true;
        setTimeout(() => {
          this.showErrorToast = false;
          this.error = ''
        }, 5000)
      }
    }, error => {
      this.utilService.SharingDataTextMessage.subscribe((res: any) => {
        this.error = res
      })
      if (this.error == 'Error Verification code has Expired') {
        this.codeExpText = 'Code Expired?'
        this.isShowTimer = false;
        this.resetForm.get('verificationCode')?.setErrors({
          expiredCode: true,
          errorMessage: 'Verification code is expired. Please resend to generate new verification code.'
        });
      } else if (this.error == 'Error Verification Code entered is invalid!') {
        this.resetForm.get('verificationCode')?.setErrors({
          expiredCode: true,
          errorMessage: 'Verification Code is Invalid'
        });
      } else {
        this.showErrorToast = true;
        setTimeout(() => { this.showErrorToast = false; this.error = ''; this.utilService.SharingDataTextMessage.next('') }, 5000)
      }
    })
  }

  
  onResetPassword() {
    this.verifyCode()
  }
  // ==================== VERIFICATION CODE METHODS - END ====================

  // ==================== PASSWORD CREATION METHODS - START ====================
  createPassword() {
    let payload = {
      "emailId": this.globalEmail.toLowerCase()?.trim(),
      "password": this.resetForm.get('newPassword').value
    }
    this.confirmEmail.createPassword(payload).subscribe((res: any) => {
      if (res.code == 200) {
        this.isShowTimer = false;
        if (this.isShowTimer == false) this.codeExpText = 'Code Expired?';
        this.showSuccessToast = true;
        this.successMsg = 'Your password has been successfully updated.'
        setTimeout(() => {
          //  this.router.navigate(['/home'])
          this.backToLogin();
          this.showSuccessToast = false;
        }, 3000);
      } else if (res.code == 500) {
        this.error = res.result.error;
        this.showErrorToast = true;
        setTimeout(() => {
          this.showErrorToast = false;
          this.error = ''
        }, 5000)
      }
    })
  }
  // ==================== PASSWORD CREATION METHODS - END ====================

  // ==================== TIMER AND COUNTDOWN METHODS - START ====================
  startCountdown(): void {
    this.isShowTimer = true;
    if (this.isShowTimer) this.codeExpText = 'Code Expires in';
    let minutes = 3; // Set initial minutes to 3
    let seconds = 0;

    this.countdownInterval = setInterval(() => {
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(this.countdownInterval);
          this.timer = '03:00'; // Reset timer display to 3 minutes
          this.isShowTimer = false;
          if (this.isShowTimer == false) this.codeExpText = 'Code Expired?';
        } else {
          minutes--;
          seconds = 59;
        }
      } else {
        seconds--;
      }

      // Format the timer to always show two digits
      this.timer = `${this.formatTime(minutes)}:${this.formatTime(seconds)}`;
    }, 1000);
  }

  formatTime(time: number): string {
    return time < 10 ? `0${time}` : time.toString();
  }
  // ==================== TIMER AND COUNTDOWN METHODS - END ====================

  // ==================== FORM SUBMISSION METHODS - START ====================
  onSubmit(): void {
    this.isSubmitted = true;
    if (this.isForgetPassword) {
      this.sendVerification();
    } else {
      this.verifyCode();
    }
  }
  // ==================== FORM SUBMISSION METHODS - END ====================

  // ==================== AUTHENTICATION METHODS - START ====================
  onLoginCall() {
    this.backToLogin();
  }

  backToLogin() {
    if (localStorage.getItem('id') == 'undefined')
      localStorage.setItem('lastVisitedUrl', '/login')
    this.router.navigateByUrl(localStorage.getItem('lastVisitedUrl'));
  }
  showSignUp() {
    this.isSignup = false;
    this.signUpSteptwo = false; // Reset signup step
    this.clearOTP(); // Clear any OTP data
    this.mainLoginForm.reset();
    this.cdr.detectChanges()
  }
  showLoginForm() {
    this.isSignup = true;
    this.signUpSteptwo = false; // Reset signup step
    this.isOtherSelected.set(false);
    this.selectedCompany = [];
    this.clearOTP(); // Clear any OTP data
    this.mainLoginForm.reset();
    this.cdr.detectChanges()
  }
  // ==================== AUTHENTICATION METHODS - END ====================

  // ==================== FORM VALIDATION METHODS - START ====================
  isLoginFormValid() {
    if (this.loginForm.valid) {
      return false;
    } else {
      return true;
    }
  }

  isMainLoginFormValid() {
    if (!this.forgotGroup && this.isSignup) {
      // Login form validation
      return (this.mainLoginForm.get('emailForLogin')?.invalid)
        || (this.mainLoginForm.get('passForLogin')?.invalid)
        ? true : false;
    } 
    else if(!this.forgotGroup && !this.isSignup && this.signUpSteptwo){
      return this.mainLoginForm.get('verificationCodeForSignUp')?.invalid
    } else if(!this.forgotGroup && !this.isSignup && !this.signUpSteptwo){
      // Full signup form validation (fallback)
      return (this.mainLoginForm.get('firstNameForSignUp')?.invalid)
      || (this.mainLoginForm.get('lastNameForSignUp')?.invalid)
      || ( this.mainLoginForm.get('selectedCompany')?.value !== null && this.mainLoginForm.get('selectedCompany')?.invalid)
      || (
        this.mainLoginForm.get('selectedCompany')?.value === 'Other' &&
        (!this.mainLoginForm.get('customCompanyName')?.value || this.mainLoginForm.get('customCompanyName')?.invalid)
      )
        || (this.mainLoginForm.get('emailForSignUp')?.invalid)
        || (this.mainLoginForm.get('passForSignup')?.invalid)
        ? true : false;
    }else {
      if (this.mainLoginForm.valid) {
        return false;
      } else {
        return true;
      }
    }
  }

  // Method to validate first step of signup (first name and last name only)
  isSignupStepOneInvalid(): boolean {
    const firstName = this.mainLoginForm.get('firstNameForSignUp');
    const lastName = this.mainLoginForm.get('lastNameForSignUp');
    
    return (firstName?.invalid || !firstName?.value?.trim()) || 
           (lastName?.invalid || !lastName?.value?.trim());
  }

  isResetFormValid() {
    if (this.resetForm.valid) {
      return false;
    } else {
      return true;
    }
  }
  // ==================== FORM VALIDATION METHODS - END ====================

  // ==================== FORM GETTERS - START ====================
  get email() {
    return this.loginForm.get('email') as FormControl;
  }

  get verificationCode() {
    return this.resetForm.get('verificationCode') as FormControl;
  }

  get newPassword() {
    return this.resetForm.get('newPassword') as FormControl;
  }

  get password() {
    return this.mainLoginForm.get('password') as FormControl;
  }

  get confirmPassword() {
    return this.resetForm.get('confirmPassword') as FormControl;
  }
  // ==================== FORM GETTERS - END ====================

  onLoginSubmit(): void {
    if(this.isSignup){
      // Handle login form submission
      this.onLogin();
    } else if(!this.signUpSteptwo) {
      // Handle first step of signup - proceed to step 2
      this.proceedToSignupStepTwo();
    } else {
      // Handle final signup form submission (step 2)
      this.onSignIn();
    }
  }

  // Method to proceed to signup step 2 after validating first step
  proceedToSignupStepTwo(): void {
    // Mark first name and last name as touched to show validation errors if any
    this.mainLoginForm.get('firstNameForSignUp')?.markAsTouched();
    this.mainLoginForm.get('lastNameForSignUp')?.markAsTouched();
    
    // Check if first step validation passes
    if (!this.isSignupStepOneInvalid()) {
       // Proceed to step 2
      this.sendVerificationForSignUp();
      this.cdr.detectChanges();
      
      // Clear OTP fields when moving to step 2
      this.clearOTP();
    }
  }

  // Method to go back to signup step 1 from step 2
  backToSignupStepOne(): void {
    this.signUpSteptwo = false;
    this.clearOTP();
    this.cdr.detectChanges();
  }

  onLogin(){
 let isPerformLogin = true;
 this.utilService.setLoginValue(isPerformLogin);
 localStorage.setItem('isLoginInProgress', 'true');
 var params = Object.assign({
      overrides: {
        __tenant: authConfig.domain,
        __token_issuer: authConfig.issuer,
      },
      domain: authConfig.domain,
      clientID: authConfig.clientId,
      redirectUri: window.location.origin,
      responseType: 'code'
    });


    let webAuth = new auth0.WebAuth(params);
    let databaseConnection = 'Username-Password-Authentication';
    localStorage.setItem('lastVisitedUrl', '/');

    webAuth.login({
      realm: databaseConnection,
      username: this.mainLoginForm.get('emailForLogin').value,
      password: this.mainLoginForm.get('passForLogin').value
    }, (err: any) => {
      this.spinnerService.hide();
      console.log(err);
      if (err) {
        isPerformLogin = false;
        this.utilService.setLoginValue(isPerformLogin);
        localStorage.setItem('isLoginInProgress', 'false');
        localStorage.setItem('lastVisitedUrl', '/login');
        this.router.navigateByUrl('/login');
        this.showErrorToast = true;
        this.error = err.error_description || err.description;

        if (this.error.includes('Wrong email or password')) {
          this.error = 'Invalid Credentials. Please try again.';

          this.mainLoginForm.get('passForLogin').setErrors({ invalid: true });
        }

        setTimeout(() => {
          this.error = '';
          this.showErrorToast = false;
        }, 3000);
      }
    });
  }

  onSignIn(){
    let verificationCode = this.getOTPValue();
     let payload = {
     "firstName":  this.mainLoginForm.value?.firstNameForSignUp,
      "lastName": this.mainLoginForm.value?.lastNameForSignUp,
      "email": this.mainLoginForm.value?.emailForSignUp,
      "companyId": this.mainLoginForm.value?.selectedCompany,
      "other": this.mainLoginForm.value?.customCompanyName,
      "password": this.mainLoginForm.value?.passForSignup,
      "verificationCode": this.mainLoginForm.value?.verificationCodeForSignUp,
    }
    this.spinnerService.show()
    this.confirmEmailService.createUser(payload).subscribe({
      next: (res: any) => {
        if (res.result) {
        this.spinnerService.hide()
        this.successMsg = res.result;
        this.showSuccessToast = true;
        setTimeout(() => {
          this.showSuccessToast = false;
        }, 3000);
        this.isOtherSelected.set(false);
        this.selectedCompany=[];
        this.mainLoginForm.reset();
        this.showLoginForm();
          
       
        }
      },
      error: (err) => {
        this.spinnerService.hide();
        this.showErrorToast = true;
        this.utilService.SharingDataTextMessage.subscribe((res: any) => {
          this.error = res
        })
         setTimeout(() => {
          this.error = '';
          this.showErrorToast = false;
        }, 3000);
       }
    })
  }
  getCompaniesList(){
    this.confirmEmailService.getCompanyList().subscribe((res: any) => {
      if (res?.result) {
        this.companies = res.result;
        this.companies.push({ id: null, companyName: 'Other' });
        this.mainLoginForm.get('customCompanyName').setAsyncValidators(companyExistsAsyncValidator(this.companies));
        this.mainLoginForm.get('customCompanyName').updateValueAndValidity();
      }
    })
  }

  // ==================== OTP VERIFICATION METHODS - START ====================
  
  /**
   * OPTIMIZED OTP IMPLEMENTATION
   * 
   * Features:
   * - Configurable OTP length via OTP_LENGTH constant
   * - Dynamic form control generation
   * - Template optimization using *ngFor
   * - Input sanitization and validation
   * - Accessibility support with ARIA labels
   * - Automatic focus management
   * - Paste handling for better UX
   * - Progress tracking and validation
   * 
   * Benefits:
   * - Reduced code duplication (~70% less HTML)
   * - Easy to modify OTP length (just change OTP_LENGTH)
   * - Better maintainability
   * - Improved accessibility
   * - Type-safe implementation
   */

  /**
   * TrackBy function for ngFor to optimize re-rendering
   */
  trackByIndex(index: any, item: any): any {
    return item;
  }

  /**
   * Generates aria-label for OTP input accessibility
   */
  getOtpAriaLabel(position: any): string {
    const positions = ['First', 'Second', 'Third', 'Fourth', 'Fifth', 'Sixth','Seventh','Eighth'];
    return `${positions[position - 1] || position} digit of verification code`;
  }

  /**
   * Sanitizes input to allow only numeric characters
   */
  private sanitizeOtpInput(value: string): string {
  //  return value.replace(/\D/g, '').slice(0, 1);
    return value.replace(/[^a-zA-Z0-9]/g, '').slice(0, 1);
  }

  /**
   * Focuses on a specific OTP input by index
   */
  private focusOtpInput(index: number): void {
    const input = document.getElementById(`otpDigit${index + 1}`) as HTMLInputElement;
    input?.focus();
  }

  onOtpDigitInput(event: any, index: number): void {
    const input = event.target;
    const sanitizedValue = this.sanitizeOtpInput(input.value);
    
    // Update input value with sanitized value
    input.value = sanitizedValue;

    // Update form control
    const controlName = `otpDigit${index + 1}`;
    this.mainLoginForm.get(controlName)?.setValue(sanitizedValue);

    // Update local array
    this.otpDigits[index] = sanitizedValue;

    // Move to next input if current input has value
    if (sanitizedValue && index < this.OTP_LENGTH - 1) {
      this.focusOtpInput(index + 1);
    }

    // Validate complete OTP
    this.validateOTP();
  }

  onOtpKeyDown(event: KeyboardEvent, index: number): void {
    const input = event.target as HTMLInputElement;

    // Handle backspace
    if (event.key === 'Backspace' && !input.value && index > 0) {
      const prevInput = document.getElementById(`otpDigit${index}`) as HTMLInputElement;
      if (prevInput) {
        prevInput.focus();
      }
    }
  }

  onOtpPaste(event: ClipboardEvent, startIndex: number): void {
    this.handlePaste(event, startIndex);
  }

  handlePaste(event: ClipboardEvent, startIndex: number): void {
    event.preventDefault();
    const paste = (event.clipboardData || (window as any).clipboardData).getData('text');
    // const digits = paste.replace(/\D/g, '').split('').slice(0, this.OTP_LENGTH - startIndex);
    const digits = paste.replace(/[^a-zA-Z0-9]/g, '').split('').slice(0, this.OTP_LENGTH - startIndex);
    digits.forEach((digit: string, i: number) => {
      const inputIndex = startIndex + i;
      if (inputIndex < this.OTP_LENGTH) {
        const input = document.getElementById(`otpDigit${inputIndex + 1}`) as HTMLInputElement;
        if (input) {
          input.value = digit;
          this.otpDigits[inputIndex] = digit;
          this.mainLoginForm.get(`otpDigit${inputIndex + 1}`)?.setValue(digit);
        }
      }
    });

    // Focus on the next empty input or last input
    const nextEmptyIndex = this.otpDigits.findIndex(digit => !digit);
    const focusIndex = nextEmptyIndex !== -1 ? nextEmptyIndex : this.OTP_LENGTH - 1;
    this.focusOtpInput(focusIndex);

    this.validateOTP();
  }

  validateOTP(): void {
    const otpString = this.otpDigits.join('');
   //  const expectedPattern = new RegExp(`^\\d{${this.OTP_LENGTH}}$`);
    const expectedPattern = new RegExp(`^[a-zA-Z0-9]{${this.OTP_LENGTH}}$`);
    this.isOtpValid = otpString.length === this.OTP_LENGTH && expectedPattern.test(otpString);
    
    if (this.isOtpValid) {
      this.otpError = '';
    } else if (otpString.length === this.OTP_LENGTH) {
      this.otpError = `Please enter a valid ${this.OTP_LENGTH}-digit verification code`;
    } else {
      this.otpError = '';
    }
  }

  clearOTP(): void {
    this.otpDigits = Array(this.OTP_LENGTH).fill('');
    for (let i = 1; i <= this.OTP_LENGTH; i++) {
      this.mainLoginForm.get(`otpDigit${i}`)?.setValue('');
      const input = document.getElementById(`otpDigit${i}`) as HTMLInputElement;
      if (input) {
        input.value = '';
      }
    }
    this.otpError = '';
    this.isOtpValid = false;
  }

  getOTPValue(): string {
    return this.otpDigits.join('');
  }

  /**
   * Checks if OTP is complete (all digits filled)
   */
  isOtpComplete(): boolean {
    return this.otpDigits.every(digit => digit !== '') && this.otpDigits.length === this.OTP_LENGTH;
  }

  /**
   * Gets the current OTP progress (number of filled digits)
   */
  getOtpProgress(): number {
    return this.otpDigits.filter(digit => digit !== '').length;
  }
  // ==================== OTP VERIFICATION METHODS - END ====================
}
